const TYPE = [
  { value: "media", label: "Media" },
  { value: "NGO", label: "NGO" },
  { value: "business", label: "Business" },
  { value: "government", label: "Government" },
  { value: "hotSpot", label: "Hot spot" },
  { value: "greenSpot", label: "Green spot" },
  { value: "NGONew", label: "NGO new" },
  { value: "businessNew", label: "Business new" },
];

export default TYPE;
